import React, { useState, useRef, useEffect } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { verifyOtp, sendOtp } from '../services/otpService'; // Import the services
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';

const OTPVerification = ({ email,language, onVerified }) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [recaptcha] = useState(true);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const recaptchaRef = useRef(null);
  const { t } = useTranslation();

  // Timer state
  const [timer, setTimer] = useState(180); // 3 minutes = 180 seconds
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  // Timer logic
  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => clearInterval(countdown);
    } else {
      setIsResendDisabled(false);
    }
  }, [timer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  const resendOtp = async () => {
    if (!recaptchaToken) {
      setError(t('validation.recaptchaEmpty'));
      return;
    }
    try {
      await sendOtp(email, language, recaptchaToken);
      setTimer(180); // Reset the timer to 3 minutes
      setIsResendDisabled(true);
    } catch (error) {
      console.log("error")
    }
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setRecaptchaToken('');
    }
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
    setRecaptchaToken('');
  };

  const handleVerify = async () => {
    try {
      const data = { email, otp };
      if (recaptchaToken) {
        data.recaptchaToken = recaptchaToken;
      }

      const response = await verifyOtp(email, otp, recaptchaToken);
      onVerified(response.token);
    } catch (error) {
      setError(t('validation.verifyOtp'));
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    }
  };

  return (
    <Container>
      <Row className="justify-content-center mt-5">
        <Col md={6}>
          <Form>
            <Form.Group controlId="formOTP">
              <Form.Label>{t('otpVerification.otp')}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t('otpVerification.otpText')}
                value={otp}
                onChange={handleOtpChange}
                maxLength={6}
                inputMode="numeric"
                title="OTP must be exactly 6 digits"
              />
            </Form.Group>
            {
              recaptcha && (
                <ReCAPTCHA className='mt-2'
              ref={recaptchaRef}
                sitekey="6LfBvuQpAAAAAMDIHg7BW5MhQO5pK_HQOAwk2hI3"
                onChange={handleRecaptchaChange}
              />
              ) 
            }
            {error && <p className="text-danger">{error}</p>}
            <Button variant="primary" onClick={handleVerify} className="mt-3">
              {t('otpVerification.verify')}
            </Button>

            <div className="mt-3">
              {/* Conditional rendering for the timer text */}
              {timer > 0 && (
                <p>{t('otpVerification.resendIn')} {formatTime(timer)} {t('otpVerification.resendIn2')}</p>
              )}
              <Button
                variant="success"
                onClick={resendOtp}
                className="mt-2 btn-yellow"
                disabled={isResendDisabled}
              >
                {t('otpVerification.resend')}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default OTPVerification;
